<template>
    <div>

        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

        <PageTitle v-bind:title="title" v-bind:admin="false" />





        <!-- <h1>Тестирование к Главе.</h1> -->


        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>
        <Loader v-if="loading" />
        <div v-else-if="data.questions.length">
            <!--
            <p>Курс: <router-link :to="{ name: 'course_show', params: { id: data.course.id } }">{{ data.course.name }}</router-link></p>
            <p>Глава: <router-link :to="{ name: 'chapter_show', params: { id: data.chapter.id } }">{{ data.chapter.name }}</router-link></p>
            -->


            <div v-if="!data.canFinishChapter" class="section">
                <div class="card shadow p-4 m-3">
                    <h3>Тестирование выполнено на {{ progress }}%</h3>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" :style="'width: ' + (progress) +'%'" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <p class="small mt-3">Осталось вопросов: {{ data.questions_count - data.questions_finished_count}}</p>
                </div>
            </div>



            <ChapterMarkAndFinish v-if="data.canFinishChapter" v-bind:chapter="data.chapter" v-bind:caption="'Тестирование завершено!'" />
            <!--
            <div class="alert alert-success" v-if="data.canFinishChapter">
                <p>Тестирование завершено!</p>
                <p>
                    Перейдите к 
                    <router-link :to="{ name: 'chapter_show', params: { id: data.chapter.id } }">Главе</router-link>
                    и нажмите "Завершить главу"!
                </p>
            </div>
            -->




            <table class="custom-table">
                <thead>
                    <tr class="custom-table__header">
                        <th class="custom-table__col--25">id</th>
                        <th>Вопрос</th>
                        <!-- <th>Статус</th> -->
                        <!-- <th>Сортировка</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.questions" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>
                            <router-link :to="{ name: 'question_show', params: { id: item.id } }">{{ item.name }}</router-link>&nbsp;
                            <span v-if="item.status_id == 5" class="badge badge-success">отвечен</span>
                        </td>
                        <!--
                        <td>
                            {{ item.status }}
                        </td>
                        -->
                        <!-- <td>{{ item.orderby }}</td> -->

                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import BreadCrumbs from '@/components/BreadCrumbs'
import PageTitle from '@/components/PageTitle'
import ChapterMarkAndFinish from '@/components/ChapterMarkAndFinish'
//import jQuery from 'jquery'
export default {
    data() {
        return {
            loading: true,
            data: [],
            id: 0,
            name: '',
            errors: {load: ''},
            title: 'Тестирование',
            bcrumbs: [],
        }
    },
   async mounted() {
       this.loadRecords()
    },
    methods: {
        async loadRecords() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('chapters/'+this.$route.params.id+'/questions')
                this.data = response.data
                this.bcrumbs = response.data.bcrumbs
                this.loading = false
            }
            catch (e) {
                if (e.response.status == 401) {
                    this.errors.load = e.response.data.error
                }
                else {
                    this.errors.load = 'Ошибка при загрузке данных'
                }
            }
        },
    },
    computed: {
        progress() {
            return Math.round(100 * this.data.questions_finished_count / this.data.questions_count)
        }
    },
    components: {
        Loader,
        BreadCrumbs,
        PageTitle,
        ChapterMarkAndFinish,
    }
}
</script>


<style scoped>
        .custom-table {
            width: 100%;
            overflow: hidden;
            border-collapse: collapse;
            border-radius: 30px;
            border-radius: 10px;
            box-shadow: 0 0  2px 1px #E4E7EB;         
        }


        .custom-table__col--10 {
            width: 10%;
        }

        .custom-table__col--25 {
            width: 25%;
        }
        
        .custom-table__col--50 {
            width: 50%;
        }

        .custom-table__col--75 {
            width: 75%;
        }


        .custom-table__header {
            border-radius: 10px;
            background-color: #F5F7FA;
        }
        .custom-table__header th {
            text-transform: uppercase;
            font-weight: 400;
            font-size: .8rem;
            color: #166086;
        }

        .custom-table th, .custom-table td {
            padding: 15px 20px;
            border-bottom: 1px solid hsl(214, 15%, 91%);
        }
</style>